import {
    INCIDENT_CONTAINMENT_STATUS_PROCESSING,
    INCIDENT_CONTAINMENT_STATUS_REQUESTED,
    INCIDENT_CONTAINMENT_STATUS_SUCCESSED,
    INCIDENT_CONTAINMENT_STATUS_FAILED,
  } from '../../constants/actionTypes';
   
  const initialState = {
    result: {},
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
  };
  
  export const incidentMasterContainmentStatus = (state = initialState, action) => {
    switch (action.type) {
      case INCIDENT_CONTAINMENT_STATUS_REQUESTED: {
        return {
          ...state,
          error: null,
          loading: true,
          requested: true,
        };
      }
      case INCIDENT_CONTAINMENT_STATUS_PROCESSING: {
        return {
          ...state,
          error: null,
          loading: true,
          requested: false,
        };
      }
      case INCIDENT_CONTAINMENT_STATUS_SUCCESSED: {
        return {
          ...state,
          result: action.data,
          error: null,
          loading: false,
          requested: false,
        };
      }
      case INCIDENT_CONTAINMENT_STATUS_FAILED: {
        return {
          ...state,
          result: {},
          error: action.data,
          loading: false,
          requested: false,
        };
      }
  
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default incidentMasterContainmentStatus;
  